export default __webpack_public_path__ + "static/awarepath-cover-small-ce7aad7925a4d8626d9de8b4456ac369.png";